import React from 'react';

interface HeaderProps {
  isCalculating?: boolean;
}

export const Header: React.FC<HeaderProps> = ({ 
  isCalculating = false 
}) => {
  return (
    <header className="py-4">
      <div className="max-w-7xl mx-auto px-6">
        {/* Logo and Title on same line */}
        <div className="flex items-center space-x-6">
          <img 
            src="/logo.webp" 
            alt="Logo" 
            className="w-[120px] h-auto lg:w-[140px]"
          />
          <div className="text-center flex-1">
            <h1 className="text-2xl lg:text-3xl font-bold text-white">
              Queueing Theory Analytics
            </h1>
            <p className="text-sm text-gray-300">
              Advanced G/G/m System Analysis Platform
            </p>
          </div>
        </div>

        {/* Status Bar */}
        {isCalculating && (
          <div className="mt-3 flex items-center justify-center space-x-2 text-sm text-primary-400">
            <div className="w-2 h-2 bg-primary-400 rounded-full animate-pulse"></div>
            <span>Calculating metrics and generating visualizations...</span>
          </div>
        )}
      </div>
    </header>
  );
};